import React from "react";
import classNames from "classnames";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourceTimeOverview({ type }: Props) {
  return (
    <div
      className={classNames(styles.resourceTimeOverview, {
        [styles.resource]: type === "resource",
        [styles.list]: type === "list" || type === "project",
        [styles.task]: type === "task",
      })}
    >
      <div className={styles.cell}>
        <Skeleton className={styles.text} />
      </div>
      <div className={styles.cell}>
        <Skeleton className={styles.text} />
      </div>
      <div className={styles.cell}>
        <Skeleton className={styles.text} />
      </div>
      <div className={styles.cell}>
        <Skeleton className={styles.text} />
      </div>
      <div className={styles.cell}>
        <Skeleton className={styles.text} />
      </div>
    </div>
  );
}

export { ResourceTimeOverview };
